// Vue
import { ref } from "vue";

// Dependencies
import { defineStore } from "pinia";

// Types
import { ReferenceAreaTypeOptionType } from "../types/ReferenceAreaTypeOptionType";

// GraphQL
import { GetReferenceAreaTypesQuery } from "@/graphql";

interface ReferenceAreaTypeOptionsProvider {
  // Getters
  getReferenceAreaTypeOptions: () => ReferenceAreaTypeOptionType[];
  mapData: (data: GetReferenceAreaTypesQuery) => void;

  getLoading: () => boolean;
  setLoading: (newValue: boolean) => void;
}

const useReferenceAreaTypeOptions = defineStore("ReferenceAreaTypeOptionsProvider", (): ReferenceAreaTypeOptionsProvider => {
  // ///////////////////
  // Data
  // ///////////////////

  // ///////////////////
  // Refs
  // ///////////////////

  const referenceAreaTypeOptions = ref<ReferenceAreaTypeOptionType[]>([]);

  // ///////////////////
  // Getters
  // ///////////////////

  function getReferenceAreaTypeOptions() {
    return referenceAreaTypeOptions.value;
  }

  // ///////////////////
  // Setters
  // ///////////////////

  function setReferenceAreaTypeOptions(newReferenceAreaTypeOptions: ReferenceAreaTypeOptionType[]) {
    referenceAreaTypeOptions.value = newReferenceAreaTypeOptions;
  }

  // ///////////////////
  // Methods
  // ///////////////////

  // function init() {
  //     mapData({ referenceArea: referenceAreaTypeEnums });
  // }

  function mapData(data: GetReferenceAreaTypesQuery) {
    const { referenceAreaTypeCalculationTypeMapping } = data;

    // Map all transport to ReferenceAreaTypeOptionType
    if (!referenceAreaTypeCalculationTypeMapping) return;
    const mappedReferenceAreaTypeOptions: ReferenceAreaTypeOptionType[] = referenceAreaTypeCalculationTypeMapping.map((e) => {
      const { label, multiplier, key } = e.referenceAreaType;
      return {
        value: key,
        label,
        multiplier: multiplier as number,
      };
    });

    setReferenceAreaTypeOptions(mappedReferenceAreaTypeOptions);
  }

  const loading = ref<boolean>(false);

  function setLoading(newValue: boolean) {
    loading.value = newValue;
  }

  function getLoading() {
    return loading.value;
  }

  // ///////////////////
  // Returns
  // ///////////////////

  return {
    getReferenceAreaTypeOptions,
    mapData,

    getLoading,
    setLoading,
  };
});

export default useReferenceAreaTypeOptions;
